import { render, staticRenderFns } from "./LicenseNameInput.vue?vue&type=template&id=5a045b7e&scoped=true"
import script from "./LicenseNameInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicenseNameInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LicenseNameInput.vue?vue&type=style&index=0&id=5a045b7e&prod&scoped=true&lang=scss"
import style1 from "./LicenseNameInput.vue?vue&type=style&index=1&id=5a045b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a045b7e",
  null
  
)

export default component.exports